import { useTicketing } from 'global/cnr/contexts/useHelpers/useTicketing';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import _ from 'lodash';
import { useMemo, useState } from 'react';
import { Button, Icon, Label } from 'semantic-ui-react';
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';

const UserTicketStatus = (props) => {

  const { userTicketStatus, handleCancel, currentTicket } = props
  const { appUser, appUserTicket } = userTicketStatus ?? {}
  const { firstName, lastName, _itemKey } = appUser ?? {}
  const { _itemKey: ticketKey } = currentTicket ?? {}
  const { subTickets, allotment } = appUserTicket ?? {}
  const userName = firstName + ' ' + lastName

  const [currentAllotment, setCurrentAllotment] = useState(allotment)
  const [allowUpdate, setAllowUpdate] = useState()

  const { updateAppUserTicket, updating } = useTicketing()

  const handleAllotment = (add) => {
    const _currentAllotment = add ? currentAllotment + 1 : currentAllotment - 1
    setCurrentAllotment(_currentAllotment)
    setAllowUpdate(true)
  }

  const handleSave_allotment = (add) => {
    updateAppUserTicket({ ticketKey, registrationId: _itemKey, allotment, currentAllotment, subTickets })
  }

  const _subTickets = useMemo(() => {
    _.forEach(subTickets, st => {
      st.name = st.subTicketIndex
    })
    return subTickets
  }, [subTickets])

  const fnAlt = (item) => {
    const { entered, assignedTo } = item
    return <div>
      {assignedTo || userName}
      <Icon
        style={{ marginLeft: '1em' }}
        name={'user'}
        color={assignedTo ? 'blue' : 'green'}
      />
      <Icon
        style={{ marginLeft: '1em' }}
        name={entered ? 'sign-in' : 'circle outline'}
        color={entered ? 'green' : 'grey'}
      />
    </div>
  }

  const userStatusContent = () => <ItemMenuSquares
    menuItems={_subTickets}
    imsType={_imsTypes.inline}
    fn_altContent={fnAlt}
    iconItem={'user'}
  />

  const footer_allotment = () => {
    return <div style={{ display: 'flex', padding: '0 .5em', columnGap: '.5em', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', columnGap: '.5em', alignItems: 'center', justifyContent: 'center' }}>
        <div><Icon name='minus' color='red' onClick={() => { handleAllotment(false) }}></Icon></div>
        <Label>{currentAllotment}</Label>
        <div><Icon name='plus' color='green' onClick={() => { handleAllotment(true) }}></Icon></div>
      </div>
      <div>
        <Button
          content='Save Alltoment'
          size='mini'
          color='green'
          icon='save'
          labelPosition='right'
          disabled={!allowUpdate}
          onClick={() => { handleSave_allotment(true) }}
        />
      </div>
    </div>
  }

  const userStatusWrapper = () => <Wrapper
    header={`Ticket Key: ${ticketKey}`}
    content={userStatusContent()}
    footer={footer_allotment()}
    wrapperType={wrapperTypes.padded}
    updating={updating}
  />

  const stepWizardUserStatus = () => <FullPageWrapper
    content={userStatusWrapper()}
    handleCancel={handleCancel}
    topperCaption={'App User Ticket Status'}
    topperCaption2={`${userName} - ${_itemKey}`}
    isBack={true}
    css={{ container: 'app-dark-mode' }}
  />

  return stepWizardUserStatus()

}

export default UserTicketStatus